module.exports = __webpack_public_path__ + "media/newstyle/images/arquivo2-350cae3585dc111c706776a2b671cd9a.png";